import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchFilteredProducts = createAsyncThunk(
    
  'products/fetchFilteredProducts',
  async (filters, { rejectWithValue }) => {
    try {
      const token = JSON.parse(localStorage.getItem("userTools"));
      const response = await axios.get(`${BASE_URL}/products/filter`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${token?.token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching products');
    }
  }
);
